<div class="mark-disable-wrapper">
  <div class="summary-box">
    <h3>{{ distributorName }}</h3>
    <p class="location">{{ address }}</p>
    <div class="stats">
      <div>
        <label>SPs</label>
        <p>{{ totalSpCount }}</p>
      </div>
      <div>
        <label>Customer</label>
        <p>{{ totalCustomerCount }}</p>
      </div>
    </div>
  </div>

  <p>Please assign a distributor for SPs and Customers to disable {{ distributorName }}.</p>

  <div class="form-group">
    <label for="distributor">Assign a distributor</label>
    <p-dropdown
  [options]="distributors"
  [(ngModel)]="selectedDistributor"
  placeholder="Select"
  optionLabel="name"
  [showClear]="true"
  [virtualScroll]="true"
  [itemSize]="50"
  [style]="{ width: '100%' }"
  [panelStyle]="{ maxHeight: '300px' }"
  appendTo="body"
>
  <ng-template let-dist pTemplate="item">
    <div class="dropdown-item">
      <!-- <img [src]="dist.image" width="32" height="32" class="avatar" /> -->
       <div class="avatar">{{ getAvatarText( dist.name) }} </div>
      <div>
        <div class="name">{{ dist.name }}</div>
        <div class="location">{{ dist.address }}</div>
      </div>
    </div>
  </ng-template>
</p-dropdown>

  </div>

  <div class="dialog-footer" style="margin-top: 20px; text-align: right;">
    <button pButton label="Cancel" (click)="onCancel()" class="btn-cancel btn" ></button>
    <button pButton label="Submit" (click)="submit()" class="btn-primary" ></button>
  </div>
</div>
